<ra-modal [size]="'fullscreen'" [title]="('document.edit.listFavoriteFields.title' | translate)" (close)="close.emit()">

    @if (loading())
    {
        <div class="container-loading">
            <ra-loading [message]="('document.edit.listFavoriteFields.loadingFields' | translate)" />
        </div>
    }
    @else if (favoriteFields().length === 0)
    {
        <div class="container-empty">
            <ra-empty
                [title]="('document.edit.listFavoriteFields.emptyTitle' | translate)"
                [message]="('document.edit.listFavoriteFields.emptyMessage' | translate)"
            />
        </div>
    }
    @else
    {
        <div class="container-master-detail">

            <!-- Filtro por tipo: mostra no painel só os cards da família clicada;
                 a seleção acontece nos próprios cards e sobrevive à troca de filtro. -->
            <div class="container-list" role="radiogroup" [attr.aria-label]="('document.edit.listFavoriteFields.title' | translate)">

                <button
                    type="button"
                    class="list-item"
                    role="radio"
                    [class.selected]="typeFilter() === 'all'"
                    [attr.aria-checked]="typeFilter() === 'all'"
                    (click)="typeFilter.set('all')">

                    <span class="item-icon item-icon-all">
                        <ra-icon icon="grid-2" varColor="currentColor" [size]="16" />
                    </span>

                    <span class="item-name">{{ 'document.edit.listFavoriteFields.filterAll' | translate }}</span>
                    <span class="item-count">{{ favoriteFields().length }}</span>
                </button>

                @for (filter of availableFilters(); track filter.group)
                {
                    <button
                        type="button"
                        class="list-item"
                        role="radio"
                        [class.selected]="typeFilter() === filter.group"
                        [attr.aria-checked]="typeFilter() === filter.group"
                        (click)="typeFilter.set(filter.group)">

                        <span class="item-icon" [ngClass]="'item-icon-' + filter.group">
                            <ra-icon [icon]="groupIcon(filter.group)" varColor="currentColor" [size]="16" />
                        </span>

                        <span class="item-name">{{ groupLabel(filter.group) | translate }}</span>
                        <span class="item-count">{{ filter.count }}</span>
                    </button>
                }
            </div>

            <!-- Painel: os campos do filtro atual empilhados; clicar no card seleciona -->
            <div class="container-detail">
                <div class="container-cards">
                    @for (favoriteField of filteredFavoriteFields(); track favoriteField._id)
                    {
                        @let item = favoriteField.field;
                        @let fieldSize = item.size | fileSizeParts:'GB';
                        @let selected = isSelected(favoriteField._id);

                        <div
                            class="favorite-card"
                            [class.selected]="selected"
                            role="checkbox"
                            tabindex="0"
                            [attr.aria-checked]="selected"
                            (click)="toggleSelection(favoriteField, $event)"
                            (keydown.enter)="toggleSelection(favoriteField, $event)"
                            (keydown.space)="toggleSelection(favoriteField, $event)">

                            <div class="favorite-card-header">
                                <span class="card-name">{{ favoriteField.description || (item | cardTypeFormat | translate) }}</span>

                                <span class="header-right">
                                    <span class="type-chip" [ngClass]="'type-chip-' + fieldGroup(item)">
                                        <ra-icon [icon]="typeIcon(item)" varColor="currentColor" [size]="12" />
                                        {{ item | cardTypeFormat | translate }}
                                    </span>

                                    @if (selected)
                                    {
                                        <span class="check-circle checked">
                                            <ra-icon icon="tick" varColor="contentInverse" [size]="12" />
                                        </span>
                                    }
                                    @else
                                    {
                                        <span class="check-circle"></span>
                                    }
                                </span>
                            </div>

                            <div class="favorite-card-content">
                                @if (item.type == 'TEXT' || item.type == 'SUBTITLE' || item.type == 'TITLE')
                                {
                                    <!-- pointer-events off: o clique no preview de texto abriria o composer -->
                                    <div class="preview-static">
                                        <text-card [type]="cardTypes.FAVORITE" [favoriteField]="favoriteField" />
                                    </div>
                                }
                                @else if (item.type == 'IMAGE')
                                {
                                    <image-card [type]="cardTypes.FAVORITE" [favoriteField]="favoriteField" />
                                }
                                @else if (item.type == 'VIDEO')
                                {
                                    <video-card [type]="cardTypes.FAVORITE" [favoriteField]="favoriteField" />
                                }
                                @else if (item.type == 'GROUP_IMAGE')
                                {
                                    <group-image-card [type]="cardTypes.FAVORITE" [favoriteField]="favoriteField" />
                                }
                                @else if (item.type == 'CALLOUT')
                                {
                                    <div class="preview-static">
                                        <callout-card [type]="cardTypes.FAVORITE" [favoriteField]="favoriteField" />
                                    </div>
                                }
                                @else if (item.type == 'STATS')
                                {
                                    <stats-card [type]="cardTypes.FAVORITE" [favoriteField]="favoriteField" />
                                }
                                @else if (item.type == 'TABLE')
                                {
                                    <table-card [type]="cardTypes.FAVORITE" [favoriteField]="favoriteField" />
                                }
                                @else if (item.type == 'SEMAPHORE')
                                {
                                    <semaphore-card [type]="cardTypes.FAVORITE" [favoriteField]="favoriteField" />
                                }
                                @else if (item.type == 'CHART')
                                {
                                    <chart-card [type]="cardTypes.FAVORITE" [favoriteField]="favoriteField" />
                                }
                            </div>

                            <div class="favorite-card-meta">{{ fieldSize.value }} {{ fieldSize.unit }}</div>
                        </div>
                    }
                </div>

                <div class="container-actions">
                    @if (selectedCount() > 1)
                    {
                        <span class="selected-hint">{{ 'document.edit.listFavoriteFields.selectedCount' | translate:{ count: selectedCount() } }}</span>
                    }

                    <ra-button
                        [type]="'primary-outline'"
                        [label]="('common.cancel' | translate)"
                        [disabled]="loadingAddFavoriteField()"
                        (click)="close.emit()"
                    />
                    <ra-button
                        [label]="selectedCount() > 1
                            ? ('document.edit.listFavoriteFields.addToDocumentCount' | translate:{ count: selectedCount() })
                            : ('document.edit.listFavoriteFields.addToDocument' | translate)"
                        [disabled]="selectedCount() === 0"
                        [loading]="loadingAddFavoriteField()"
                        (click)="addSelectedFavoriteFields()"
                    />
                </div>
            </div>
        </div>
    }
</ra-modal>
